import React,{useState} from 'react'
import { Link } from 'react-router-dom'

import image from '../assets/images/startup/01.jpg'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'

import { TypeAnimation } from 'react-type-animation';

export default function AboutTwo() {
    let [isOpen, setOpen] = useState(false);
  return (
        <div className="row align-items-center">
            <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0 order-2 order-md-1">
                <div className="section-title">
                    <h4 className="title mb-4">Forget about design limits ! <br/> Build and customize your 

                    <TypeAnimation
                        sequence={[
                            // Same substring at the start will only be typed out once, initially
                            'Agency',
                            1000, // wait 1s before replacing "Mice" with "Hamsters"
                            'Software',
                            1000,
                            'Technology',
                            1000,
                            'Studio',
                            1000
                        ]}
                        wrapper="span"
                        speed={10}
                        repeat={Infinity}
                        className="text-primary typewrite ms-2"
                        cursor={false}
                        />
                    </h4>
                    <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    <p className="text-muted">There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space. These alternatives to the classic Lorem Ipsum texts are often amusing and tell short, funny or nonsensical stories.</p>
                    <Link to="#" className="btn btn-outline-primary mt-2">Choose Now <i className="mdi mdi-check"></i></Link>
                </div>
            </div>

            <div className="col-md-6 order-1 order-md-2">
                <div className="position-relative ms-md-4">
                    <img src={image} className="img-fluid rounded shadow" alt=""/>
                    <div className="play-icon">
                        <Link to="#" onClick={() => setOpen(true)} className="play-btn lightbox video-play-icon">
                            <i className="mdi mdi-play text-primary rounded-pill bg-white shadow"></i>
                        </Link>
                    </div>
                    <ModalVideo
                        channel="youtube"
                        youtube={{ mute: 0, autoplay: 0 }}
                        isOpen={isOpen}
                        videoId="yba7hPeTSjk"
                        onClose={() => setOpen(false)}
                    />
                </div>
            </div>
        </div>
  )
}
